import api from "../../../services/api";

const APIS = {
    SCHEDULER_SUMMARY: "/Scheduler/current-sample-list",
    ANALYST_ASSIGNED_SAMPLES: "/Scheduler/analystassignedsamples",
    PRODUCT_SAMPLES: "/Scheduler/schedulersummary/unassignedproducts/productTypeName",
    UNASSIGN_SAMPLES: "/Scheduler/unassign-samples",
    ASSIGN_SAMPLES: "/Scheduler/assign-samples",
    ANALYST_NAMES: "/Users/analyst-names",
    ASSIGNED_PRODUCTS_COUNT: "/Scheduler/assigned-products-count-by-analyst-and-date",
    SAMPLES_FOR_REMOVE: "/Sample/Samples-for-remove"
};

const getAnalystId = () => {
    try {
        const userData = localStorage.getItem('userData');
        if (userData) {
            const parsed = JSON.parse(userData);
            return parsed.custId || parsed.id || parsed.userID || null;
        }
        return null;
    } catch (err) {
        console.error("Error parsing userData:", err);
        return null;
    }
};

export const getSchedulerSummary = async (params) => {
    try {
        const response = await api.get(APIS.SCHEDULER_SUMMARY, { params });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAnalystAssignedSamples = async (params) => {
    try {
        const requestParams = {
            fromDate: params.fromDate,
            toDate: params.toDate
        };
        if (window.location.pathname === "/analyst-scheduler") {
            const analystId = getAnalystId();
            if (analystId) {
                requestParams.custId = analystId;
            }
        }
        const response = await api.get(APIS.ANALYST_ASSIGNED_SAMPLES, {
            params: requestParams
        });
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getProductSamples = async (productTypeName) => {
    try {
        const response = await api.get(`${APIS.PRODUCT_SAMPLES}?productTypeName=${encodeURIComponent(productTypeName)}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const unassignSamples = async (sampleIds) => {
    try {
        const response = await api.post(APIS.UNASSIGN_SAMPLES, sampleIds);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const assignSamples = async (payload) => {
    try {
        const formattedPayload = {
            Analyst: payload.Analyst,
            SampleIds: payload.SampleIds,
            DateToWorkOn: payload.DateToWorkOn
        };
        const response = await api.post(APIS.ASSIGN_SAMPLES, formattedPayload);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAnalystNames = async () => {
    try {
        const response = await api.get(APIS.ANALYST_NAMES);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getAssignedProductsCount = async (analystName, date) => {
    try {
        const url = `${APIS.ASSIGNED_PRODUCTS_COUNT}?analystName=${encodeURIComponent(analystName)}&date=${date}`;
        const response = await api.get(url);
        return response.data;
    } catch (error) {
        throw error;
    }
};

export const getSamplesForRemove = async (sampleIds) => {
    try {
        const response = await api.post(APIS.SAMPLES_FOR_REMOVE, sampleIds);
        return response.data;
    } catch (error) {
        throw error;
    }
};
